import React, {useCallback, type JSX} from 'react';
import {Box, Button, Container, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import {useGuestPortalStore} from '../store';
import {PAGE_TYPE} from '../constants/types';
import {stringToReferenceCodeFormat} from '../utils/formatReferenceCode';
import {BlockContainer} from './shared';

const StyledCodeField = styled(Typography)(({theme}) => ({
  color: theme.palette.primary.main,
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2, 2),
  width: '100%',
}));

const StyledProcessRequestButton = styled(Button)(({theme}) => ({
  '&.MuiButton-root': {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: theme.spacing(2.25),
    lineHeight: theme.spacing(3),
    padding: theme.spacing(2),
    height: theme.spacing(7),
  },
}));

function ThankYouBlock(): JSX.Element {
  const referenceCode = useGuestPortalStore(state => state.referenceCode);
  const setPage = useGuestPortalStore(state => state.setPageType);

  const redirectToLoginPage = useCallback(() => {
    setPage(PAGE_TYPE.LOGIN);
  }, [setPage]);

  return (
    <BlockContainer>
      <Container maxWidth="md">
        <Typography component="h3" variant="h3" align="center" marginBottom={3}>
          Thank you for your response.
        </Typography>
        <Typography component="p" variant="body4" align="center">
          Your patient will be notified that you have fulfilled their request.
        </Typography>
        <Typography
          component="p"
          variant="body4"
          align="center"
          marginBottom={3}
        >
          The reference code for this transaction is:
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          flexDirection="column"
          paddingLeft={12}
          paddingRight={12}
        >
          <StyledCodeField variant="h4" textAlign="center" marginBottom={3}>
            {stringToReferenceCodeFormat(referenceCode)}
          </StyledCodeField>

          <StyledProcessRequestButton
            onClick={redirectToLoginPage}
            variant="outlined"
            color="primary"
            size="large"
            data-testid="new-request-btn"
          >
            Process Next Request
          </StyledProcessRequestButton>
        </Box>
      </Container>
    </BlockContainer>
  );
}

export default ThankYouBlock;
